import React from 'react'
import { Link, Navigate, useParams } from 'react-router-dom'
import ClaimStatsPage from './ClaimStats'

const OPS_STATS_TABS = [
  { key: 'claims', label: '청구', path: '/ops/stats/claims', Component: ClaimStatsPage },
]

export default function OpsStatsPage() {
  const { tab } = useParams()
  const activeTab = OPS_STATS_TABS.find((item) => item.key === tab)

  if (!activeTab) {
    return <Navigate to="/ops/stats/claims" replace />
  }

  const ActivePage = activeTab.Component

  return (
    <section className="space-y-4">
      <header>
        <h1 className="text-2xl font-bold text-slate-900">운영통계</h1>
      </header>

      <div className="border-b border-slate-200">
        <nav className="-mb-px flex flex-wrap gap-1" aria-label="운영통계 탭">
          {OPS_STATS_TABS.map((item) => {
            const active = item.key === activeTab.key
            return (
              <Link
                key={item.key}
                to={item.path}
                aria-current={active ? 'page' : undefined}
                className={`inline-flex min-h-[2.75rem] items-center border-b-2 px-3 text-sm font-semibold transition-colors ${
                  active
                    ? 'border-brand-navy text-brand-navy'
                    : 'border-transparent text-slate-500 hover:border-slate-300 hover:text-slate-800'
                }`}
              >
                {item.label}
              </Link>
            )
          })}
        </nav>
      </div>

      <ActivePage embedded />
    </section>
  )
}
